import React, { useEffect, useRef, useState } from 'react';
import Fade from 'react-reveal/Fade';
import { useStaticQuery, graphql } from 'gatsby';
import Text from 'common/components/Text';
import Button from 'common/components/Button';
import Heading from 'common/components/Heading';
import Container from 'common/components/UI/Container';
import BannerWrapper, {
  BannerContent,
  BannerImage,
  ButtonGroup,
} from './banner.style';

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      title1: 'Simplify the Enterprise with AI Agents.',
      title2: 'One Platform, Infinite Solutions.',
      description:
        "Unlock the full potential of your enterprise with NadiAI’s AI-powered automation. Our intelligent agents enable seamless interactions across industries, turning data into actionable insights and automating complex workflows.",
    },
    /*{
      title1: 'No professional left behind in the AI revolution.',
      title2: '',
      description:
        '',
    },*/
  ];

  const data = useStaticQuery(graphql`
    query {
      illustration: file(relativePath: { eq: "image/cryptoModern/banner-bg.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
    }
  `);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <BannerWrapper id="home">
      <BannerImage>
        <Fade in delay={100}>
          <video
            src="/videos/hero-banner.mov"
            width="100%"
            loop
            autoPlay
            muted
            playsInline
            id="myvideo"
          >
            <source type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Fade>
      </BannerImage>

      <Container>
        {slides.map((slide, index) => (
          <BannerContent
            key={index}
            className="bannercontent"
            style={{
              display: index === currentSlide ? 'block' : 'none',
              transition: 'opacity 0.5s ease',
            }}
          >
            <Fade up delay={100}>
              <Heading as="h1" content={slide.title1} />
              <Heading as="h1" content={slide.title2} />
            </Fade>
            <Fade up delay={200}>
              <Text content={slide.description} />
            </Fade>
            <Fade up delay={300}>
              <ButtonGroup
                style={{ textAlign: 'center', display: 'inherit' }}
                as="a"
                href="https://hub.nadiai.ai/#/portal/signup"
              >
                <Button className="primary" title="SUBSCRIBE NOW" />
              </ButtonGroup>
            </Fade>
          </BannerContent>
        ))}
      </Container>
    </BannerWrapper>
  );
};

export default Banner;
